import React from 'react';
import { AppModal } from '../AppModal';

import './EULAModal.scss';

export const EULAModal = ({ open, onCancel }) => {
    return (
        <AppModal
            open={open}
            footer={null}
            onCancel={onCancel}
            styles={{
                body: {
                    maxHeight: '50vh',
                    overflowY: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <div className="eula">
                <h1 className="title">RiverMeadow Software, Inc.</h1>
                <h2 className="title">End-User Terms of Use and License Agreement</h2>
                <p>
                    This End-User License Agreement (this “Agreement”) is between the individual or entity accepting it
                    (the “End User” or “you”) and RiverMeadow Software, Inc. (“RiverMeadow”), and governs your
                    acquisition and use of RiverMeadow’s Platform (the “RiverMeadow Platform,” defined below).
                </p>
                <p>
                    If you are entering into this Agreement on behalf of a company or other legal entity, you represent
                    hat you have the authority to bind such entity and its affiliates to these terms and conditions, in
                    which case the terms “End User” or “you” shall refer to such entity and its affiliates.
                </p>
                <p>
                    This Agreement is effective as of the date you accept it, either by clicking a box indicating your
                    acceptance or executing a document that incorporates THIS AGREEMENT BY reference.
                </p>
                <p>
                    READ THE TERMS AND CONDITIONS OF THIS AGREEMENT CAREFULLY BEFORE ACCEPTING OR USING THE SOFTWARE OR
                    THE RIVERMEADOW PLATFORM. THIS LICENSE AGREEMENT REPRESENTS THE ENTIRE AGREEMENT CONCERNING THE
                    RIVERMEADOW PLATFORM BETWEEN YOU AND RIVERMEADOW AND SUPERSEDES ANY PRIOR UNDERSTANDING OR AGREEMENT
                    BETWEEN THE PARTIES. IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, DO NOT INSTALL OR USE THE
                    RIVERMEADOW PLATFORM.
                </p>

                <h3>Section 1. Definitions</h3>
                <p>
                    “Platform" means a computing platform that hosts multiple virtual machines that operate using shared
                    resources from a pool of computer servers.{' '}
                </p>
                <p>
                    “Data Server” means a computer server that hosts a software application that End User desires to
                    migrate to and operate in a Public or Private Cloud.{' '}
                </p>
                <p>
                    "Documentation" means the following documentation (in tangible, electronic or other form) that
                    RiverMeadow makes generally available to End Users of the RiverMeadow Platform: (i) RiverMeadow’s
                    user operating manuals for the RiverMeadow Platform, and (ii) RiverMeadow’s written specification
                    documents for the RiverMeadow Platform.{' '}
                </p>
                <p>
                    “End User Data” means all of End User’s information and data, including any software applications,
                    application data and Data Server images.
                </p>
                <p>
                    "Error" means a material failure of the RiverMeadow Platform to operate in accordance with the
                    functional specifications for the RiverMeadow Platform set forth in the applicable Documentation.
                </p>
                <p>
                    “Information” means, subject to the exceptions set forth in Section 8.3 below, all financial and
                    technical information, data, designs, specifications, know-how, non-public marketing strategies,
                    business and marketing plans, price lists, inventions, processes, software programs, firmware,
                    source code, algorithms, and other technical and business information and all documents and
                    materials, supplied in connection with this Agreement or the RiverMeadow Platform, which at the time
                    of disclosure is designated as confidential (or similar designation), is disclosed in circumstances
                    of confidence, or would be understood by the parties, exercising reasonable business judgment, to be
                    confidential.
                </p>
                <p>
                    “Order Form” means any quote, purchase order, Statement of Work, Software Purchase Agreement or
                    similar document and/or written agreement, mutually executed by the parties, or by a Reseller on End
                    User’s behalf, that incorporates by reference this Agreement. Any pre-printed terms or conditions on
                    an Order Form that conflict with this Agreement shall be null and void. This Agreement may be
                    superseded only by a mutually signed amendment to this Agreement.
                </p>
                <p>
                    “Reseller” means an entity that resells or distributes to End Users the rights to the RiverMeadow
                    Platform and the Documentation subject to the terms and conditions of this Agreement.
                </p>
                <p>
                    “RiverMeadow Platform” means RiverMeadow’s migration solution, which which can be operated on prem
                    or in a Public or Private cloud environment.
                </p>
                <p>
                    “Support Services” means any support and maintenance services purchased separately from this
                    Agreement in connection with the RiverMeadow Platform.
                </p>
                <p>
                    “Support Terms” means RiverMeadow’s then-current support terms that govern Support Services, as set
                    forth, and if applicable.
                </p>
                <p>
                    “Term” shall commence on the earlier of the date this Agreement is accepted by End User or the start
                    date set forth in an Order Form, and shall continue for the Term set forth in the Order Form or
                    completion of a project.
                </p>

                <h3>Section 2. Licenses</h3>

                <p>
                    2.1 <span className="underline">Grant of License.</span> Subject to the terms and conditions of this
                    Agreement, RiverMeadow grants to End User a non- transferable, non‑exclusive license during the Term
                    of the Agreement, without the right to sublicense, to:
                </p>
                <p>
                    2.1.1 use or deploy the RiverMeadow Platform to transfer software applications from one or more Data
                    Servers to any supported Public or Private Clouds, for the Term and subject to payment of the fees
                    set forth in an Order Form;
                </p>
                <p>
                    2.1.2 integrate the RiverMeadow Platform with other products and services through the use of the
                    API; and
                </p>
                <p>
                    2.1.3 use any Documentation solely in connection with the use of the RiverMeadow Platform in
                    accordance with this Agreement and make a reasonable number of copies of the Documentation for such
                    purpose.
                </p>
                <p>
                    Except as expressly set forth in this Section 2.1, End User shall have no right to reproduce or
                    distribute the RiverMeadow Platform or Documentation.
                </p>
                <p>
                    2.2 <span className="underline">License Restrictions.</span> Other than as expressly set forth
                    herein, End User shall have no right to, (i) modify or otherwise prepare derivative works of the
                    RiverMeadow Platform or Documentation, or any portion thereof, (ii) rent, lease, loan, sublicense,
                    sell or otherwise distribute the RiverMeadow Platform or Documentation, or, (iii) except as
                    expressly permitted by applicable law, reverse engineer or decompile the RiverMeadow Platform, or
                    otherwise attempt to derive or modify the source code of, or any processes, techniques, methods,
                    specifications, protocols, algorithms, interfaces, data structures, or other information embodied or
                    used in, the RiverMeadow Platform.
                </p>
                <p>
                    2.3 <span className="underline">Reservation of Rights.</span> You shall have no rights with respect
                    to the RiverMeadow Platform or Documentation except as expressly set forth herein. All rights
                    relating to the RiverMeadow Platform and Documentation that are not expressly granted hereunder to
                    End User are reserved and retained by RiverMeadow.
                </p>
                <p>
                    2.4 <span className="underline">Feedback.</span> You may provide feedback, suggestions, evaluations
                    or improvements (collectively, “Feedback”) regarding or relating to the RiverMeadow Platform. You
                    hereby grant RiverMeadow a non-exclusive, perpetual, irrevocable, royalty-free, worldwide right and
                    license to use, reproduce, disclose, sublicense, distribute, modify, and otherwise exploit any
                    Feedback without restriction in any manner now known or in the future conceived.
                </p>
                <p>
                    2.5 <span className="underline">Edited Interfaces</span>. You acknowledge that RiverMeadow has no
                    control over your development of edited interfaces with respect to the use of the RiverMeadow
                    Platform, the operation of such edited interfaces, or the effect such edited interfaces will have on
                    your systems. You acknowledge that you are solely responsible for any consequences of the operation
                    of such edited interfaces and assume all risk associated with such development, use and operation,
                    and you furthermore agree that RiverMeadow will have no responsibility and no liability to you for
                    any loss or damage in any way caused or associated with the operation of such edited interfaces.
                </p>
                <p>
                    2.6 <span className="underline">Open Source Software Licenses</span>. End User acknowledges that the
                    RiverMeadow Platform is Linux-based and portions of the RiverMeadow Platform are subject to
                    additional licenses that you shall be obligated to obtain separately from this Agreement, including
                    without limitation Ubuntu, qemu, ntfs-3g, ms-sys, 7zip and grub (“Open Source Software”) which are
                    subject to the GNU General Public License (“GPL”) as published by the Free Software Foundation. The
                    Open Source Software shall not be subject to the terms and conditions herein. RiverMeadow provides
                    no representations or warranties with respect to the Open Source Software and all implied warranties
                    are disclaimed, in accordance with the terms of the GPL and any other license or agreement that
                    affects the Open Source Software. In the event of any conflict between the terms herein and the GPL
                    or any other applicable Open Source Software license agreement (“Open Source License Agreement”),
                    the terms of the GPL or applicable Open Source License Agreement shall control. A copy of the GPL
                    licenses can be obtained at{' '}
                    <a href="http://www.gnu.org/licenses/" target="_blank">
                        http://www.gnu.org/licenses/
                    </a>
                    . The source files for the Open Source Software are available via an FTP site from RiverMeadow, and
                    can be obtained upon request submitted to support@rivermeadow.com. Notwithstanding the foregoing,
                    the GPL and other applicable Open Source License Agreements apply only to the Open Source Software
                    and do not apply, in whole or part, to the remaining portions of the RiverMeadow Platform. In no
                    event shall End User have any right to access or obtain the source code for the remaining
                    RiverMeadow Platform.
                </p>
                <p>
                    2.7 <span className="underline">End User Data</span>. You represent and warrant that you own or have
                    the right to use all End User Data that you provide to RiverMeadow in connection with the use of the
                    RiverMeadow Platform. You hereby grant to RiverMeadow a license to use any End User Data that you
                    provide to RiverMeadow in connection with the use of the RiverMeadow Platform solely for the
                    purposes of providing the services as set forth in this Agreement. You acknowledge that End User
                    Data and/or configuration may be affected as part of the services, and that RiverMeadow may install
                    applications and other tools to Data Server images as part of the services.
                </p>

                <h3>3. Warranty</h3>
                <p>
                    3.1 <span className="underline">Warranty</span>. RiverMeadow warrants to End User that during the
                    Term, the RiverMeadow Platform will be free of Errors. RiverMeadow’s sole obligation for a breach of
                    this warranty will be to use its commercially reasonable efforts to correct the Error identified in
                    such notice, provided that if RiverMeadow is unable to correct any Emergency Error or High Severity
                    Error (as defined in the Support Terms) within thirty (30) days of receiving such notice, End User
                    will have the right to terminate this Agreement, any Order Form, any Support Terms and all other
                    exhibits and amendments executed by the parties and attached to the Order Form for a refund of a
                    pro-rated portion of any services fees and support and maintenance fees actually paid by End User
                    for the remainder of the then-current Term.
                </p>
                <p>
                    3.2 <span className="underline">Limitations</span>. Notwithstanding the foregoing, the warranty in
                    Section 3.1 and RiverMeadow’s obligations set forth in Section 3.1 will not apply: (i) to the extent
                    that an Error is due to causes that are external to the RiverMeadow Platform or otherwise beyond
                    RiverMeadow’s reasonable control, including, without limitation, natural disasters, fire, smoke,
                    water, earthquakes, lightening, electrical power fluctuations or failures, or hardware or software
                    not provided by RiverMeadow; (ii) if the RiverMeadow Platform has been misused and/or not used in
                    compliance with the Documentation or this Agreement; (iii) if there has been a modification or
                    attempted modification of the RiverMeadow Platform other than by RiverMeadow; or (iv) if End User
                    has refused or otherwise failed to implement corrections, updates, enhancements, new releases or
                    other modifications provided by RiverMeadow.
                </p>
                <p>
                    3.3 <span className="underline">Disclaimer</span>. EXCEPT FOR THE EXPRESS WARRANTIES SET FORTH IN
                    SECTION 3.1, RIVERMEADOW MAKES NO OTHER REPRESENTATIONS, WARRANTIES OR CONDITIONS, EXPRESS, IMPLIED,
                    STATUTORY OR OTHERWISE, WITH RESPECT TO THE RIVERMEADOW PLATFORM, THE DOCUMENTATION, OR ANY OTHER
                    PRODUCTS OR SERVICES PROVIDED BY RIVERMEADOW, INCLUDING WITHOUT LIMITATION WARRANTIES OF
                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR DELAYS OR INTERRUPTION IN
                    SERVICE RESULTING FROM USE OF THE INTERNET AND/OR TELECOMMUNICATIONS SERVICES NOT UNDER THE CONTROL
                    OF RIVERMEADOW. The RiverMeadow Platform is not warranted to operate without interruption or
                    failure. The RiverMeadow Platform should only be used in systems designed with appropriate
                    redundancy, fault tolerance and back-up features.
                </p>

                <h3>Section 4. Support</h3>
                <p>
                    RiverMeadow will provide Support Services for the RiverMeadow Platform, if purchased by End User or
                    by a Reseller on End User’s behalf, and pursuant to the Support Terms, for the period set forth in
                    an Order Form and commencing on the date set forth in the Order Form. Notwithstanding the above,
                    RiverMeadow shall have no obligation to provide Support Services unless documented in an Order Form.
                </p>

                <h3>Section 5. Limitations of Liability</h3>
                <p>
                    5.1 <span className="underline">Maximum Liability</span>. To the maximum extent enforceable under
                    applicable law, other than for payment of license and service fees pursuant to this Agreement, the
                    entire liability of each party hereto and their respective affiliates to the other party and its
                    affiliates for damages or other amounts arising out of or in connection with the RiverMeadow
                    Platform, the Documentation, any other products or services provided by RiverMeadow, the use of any
                    of the foregoing or any other aspect of this Agreement shall not exceed the total amount actually
                    paid by End User for the RiverMeadow Platform and any other products and services provided under
                    this Agreement in the twelve (12) month period immediately preceding the event giving rise to such
                    claim.{' '}
                </p>
                <p>
                    5.2 <span className="underline">WAIVER OF CONSEQUENTIAL DAMAGES</span>. TO THE MAXIMUM EXTENT
                    ENFORCEABLE IN ACCORDANCE WITH APPLICABLE LAW, IN NO EVENT SHALL EITHER PARTY OR THEIR RESPECTIVE
                    AFFILIATES BE LIABLE TO THE OTHER PARTY OR ITS AFFILIATES FOR ANY INCIDENTAL, INDIRECT,
                    CONSEQUENTIAL, EXEMPLARY, PUNITIVE OR SPECIAL DAMAGES, OR ANY DAMAGES FOR LOST PROFITS OR REVENUE,
                    LOST DATA OR LOST BUSINESS, EVEN IF SUCH PARTY HAS BEEN ADVISED AS TO THE POSSIBILITY OF SUCH
                    DAMAGES.
                </p>
                <p>
                    5.3 <span className="underline">Loss of Use or Data.</span> In addition to the liability limitations
                    set forth above, to the maximum extent enforceable in accordance with applicable law, under no
                    circumstances will RiverMeadow or its affiliates be liable to END USER, ANY RESELLER, THEIR
                    RESPECTIVE affiliates or any other person or entity for any claim, loss or liability for
                    interruption in the operation of the RiverMeadow Platform or for any loss of data that occurs as a
                    result of in connection with the use of the RiverMeadow Platform, regardless of whether such claim,
                    loss or liability was foreseeable by RiverMeadow or RiverMeadow was informed of the possibility of
                    such claim, loss or liability.{' '}
                </p>
                <p>
                    5.4 <span className="underline">DISCLAIMERS</span>. THE LIMITATIONS IN THIS SECTION 5 SHALL APPLY
                    NOTWITHSTANDING ANY FAILURE OF AN ESSENTIAL PURPOSE OF ANY LIMITED REMEDY PROVIDED HEREIN. THE
                    PARTIES acknowledge that but for the foregoing disclaimer, THE FEES CHARGED FOR THE RIVERMEADOW
                    PLATFORM WOULD BE HIGHER AND RIVERMEADOW WOULD NOT HAVE ENTERED INTO THIS AGREEMENT. SOME
                    JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR CERTAIN LIMITATIONS ON DAMAGES, SO
                    A PORTION OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO END USER. IN THE EVENT THAT IMPLIED WARRANTIES
                    CANNOT BE EXCLUDED, ANY IMPLIED WARRANTIES ARE LIMITED IN DURATION TO THIRTY (30) DAYS FROM THE DATE
                    OF DELIVERY OF THE RIVERMEADOW PLATFORM. THIS AGREEMENT GIVES END USER SPECIFIC LEGAL RIGHTS. END
                    USER MAY HAVE OTHER RIGHTS, WHICH VARY FROM JURISDICTION TO JURISDICTION.
                </p>

                <h3>Section 6. Third-Party Rights</h3>
                <p>
                    6.1 <span className="underline">Indemnification by RiverMeadow.</span> Subject to this Section 6,
                    RiverMeadow shall (i) defend End User from any claim asserted in a legal proceeding by a third party
                    alleging that the then-current release of the RiverMeadow Platform, in the form provided by
                    RiverMeadow to End User and used in compliance with Section 2 and the Documentation, infringes such
                    third party’s copyright, trade secret, patent or other intellectual property rights (a “Claim”) and
                    (ii) pay all liabilities, damages, losses, expenses, claims, demands, suits, fines, and judgments
                    finally awarded against End User associated with such Claim (“Damages”), or any amount agreed to by
                    RiverMeadow in settlement of such Claim (“Settlement Payments”); provided that End User promptly
                    notifies RiverMeadow of any such Claim in writing, RiverMeadow is given sole and exclusive control
                    over the defense and settlement of such Claim, and End User provides all information and cooperation
                    reasonably requested by RiverMeadow in connection with the defense and settlement of such Claim. If
                    RiverMeadow assumes defense of the Claim, End User may retain its own counsel only at its own
                    expense.
                </p>
                <p>
                    6.2 <span className="underline">Fixes</span>.If any portion of the RiverMeadow Platform becomes, or
                    in RiverMeadow’s opinion is likely to become, the subject of a claim of infringement, RiverMeadow
                    may, at its option, (i) procure for End User the right to continue using the RiverMeadow Platform,
                    (ii) replace or modify the RiverMeadow Platform to make it non-infringing or reduce the likelihood
                    of infringement, such that the replacement or modification provides substantially the functionality
                    required of the RiverMeadow Platform that is replaced or modified, or (iii) terminate this Agreement
                    and, as RiverMeadow’s sole liability and End User’s sole remedy for such termination, refund to End
                    User a pro-rated portion of any license fees and support and maintenance fees actually paid by End
                    User hereunder for the remainder of the then-current term or scope of the license.
                </p>
                <p>
                    6.3 <span className="underline">Indemnification by End User</span>. End User will defend RiverMeadow
                    against any claim, demand, suit or proceeding made or brought against RiverMeadow by a third party
                    alleging that End User Date or End User’s use of the RiverMeadow Platform in breach of this
                    Agreement, infringes or misappropriates such third party’s intellectual property rights or violates
                    applicable law (a “Claim Against RiverMeadow”), and will indemnify us from any damages, attorney
                    fees and costs awarded against us as a result of, or for any amounts paid by us in settlement of, a
                    Claim Against RiverMeadow, provided we promptly notify you of any such Claim Against RiverMeadow in
                    writing, End User is given sole and exclusive control over the defense and settlement of such Claim
                    Against RiverMeadow, and we provide all information and cooperation reasonably requested by you in
                    connection with the defense and settlement of such Claim Against RiverMeadow. If End User assumes
                    defense of the Claim, RiverMeadow may retain its own counsel only at its own expense.
                </p>
                <p>
                    6.4 <span className="underline">Limitations</span>. Notwithstanding any of the foregoing,
                    RiverMeadow shall have no obligations under this Section 6 with respect to any Claim to the extent
                    that the alleged infringement is based on or arises out of: (i) any third-party hardware, software,
                    data or other materials not provided or recommended by RiverMeadow and used with the RiverMeadow
                    Platform; (ii) use of the RiverMeadow Platform other than in accordance with this Agreement and the
                    Documentation; (iii) modifications or additions to the RiverMeadow Platform not made by RiverMeadow;
                    or (iv) End User’s continuation of an allegedly infringing activity after being notified thereof.
                </p>
                <p>
                    6.5 <span className="underline">No Other Liabilities</span>. This Section 6 states the entire
                    liability of RiverMeadow with respect to any claims of infringement or misappropriation of
                    intellectual property rights.
                </p>

                <h3>Section 7. Proprietary Rights</h3>
                <p>
                    End User acknowledges that, other than Open Source Software, RiverMeadow has and shall retain all
                    right, title and interest (including, without limitation, all intellectual property rights) in and
                    to the RiverMeadow Platform and Documentation, including all modifications, improvements and
                    additions thereto and all derivative rights therein.
                </p>
                <p>
                    End User acknowledges that RiverMeadow shall remain exclusive owner of any and all developments and
                    designs made in the course of this Agreement by use of the RiverMeadow Platform, and RiverMeadow
                    shall own and retain all right, title, interest, and any intellectual property rights attached
                    thereto.
                </p>
                <p>
                    End User grants to RiverMeadow a worldwide, limited-term license to host, copy, transmit and display
                    End User Data, and any non-RiverMeadow applications and programs provided by you, as necessary for
                    RiverMeadow to provide the RiverMeadow Platform in accordance with this Agreement. Subject to the
                    foregoing limited license, RiverMeadow acquires no right, title or interest from you under this
                    Agreement in or to End User Data.
                </p>

                <h3>8. Confidentiality</h3>
                <p>
                    8.1 <span className="underline">RiverMeadow Information</span>. Except as otherwise expressly
                    provided in this Section 8.1, End User shall protect and keep confidential all RiverMeadow
                    Information. End User shall use RiverMeadow Information only for the purposes contemplated by this
                    Agreement. End User may disclose RiverMeadow Information only (i) as necessary for its use of the
                    RiverMeadow Platform in accordance with this Agreement, (ii) to End User’s employees or third-party
                    contractors who have agreed in writing to maintain such information in confidence; or (ii) if
                    required to do so by subpoena, court order or legal process, provided that RiverMeadow is provided
                    sufficient written notice to request a protective order.
                </p>
                <p>
                    8.2 <span className="underline">End User Information: Right to Disclose</span>. Except as otherwise
                    expressly provided in this Section 8.2, RiverMeadow shall protect and keep confidential all End User
                    Information and shall use End User Information only for the purposes contemplated in this Agreement
                    and for purposes of improving and enhancing the RiverMeadow Platform. RiverMeadow may disclose End
                    User Information only (i) as necessary to support End User’s use of the RiverMeadow Platform in
                    accordance with this Agreement, (ii) to RiverMeadow’s employees or third-party contractors who have
                    agreed in writing to maintain such information in confidence; or (iii) if required to do so by
                    subpoena, court order or legal process, provided that End User is provided sufficient written notice
                    to request a protective order.
                </p>
                <p>
                    8.3 <span className="underline">Exceptions</span>. Sections 8.1 and 8.2 shall not apply to
                    Information of the disclosing party that (i) is or becomes generally available to the public other
                    than through a wrongful act of the receiving party; (ii) is or becomes available to the receiving
                    party on a non-confidential basis from a source that is entitled to disclose it to the receiving
                    party; or (iii) is independently developed by the receiving party, its employees or third-party
                    contractors without access to or use of the disclosing party’s Information
                </p>
                <p>
                    8.4 <span className="underline">RiverMeadow Platform; Documentation</span>. End User acknowledges
                    that the RiverMeadow Platform and Documentation constitute RiverMeadow Information.
                </p>

                <h3>Section 9. Duration, Termination and Fees</h3>
                <p>
                    9.1 <span className="underline">Duration</span>. RiverMeadow shall provide the services and the
                    license rights granted herein for the term of an Agreement. End User and RiverMeadow may extend or
                    renew the services upon written agreement.
                </p>
                <p>
                    9.2 <span className="underline">Fees & Charges</span>. End User shall pay all license fees, service
                    fees and other charges set forth in an Order Form according to the terms of this Agreement. Any
                    failure to pay such fees and charges shall constitute a material breach of this Agreement.
                </p>
                <p>
                    9.3 <span className="underline">Payments and Late Fees</span>. Undisputed payments are due in full
                    within thirty (30) calendar days after the date of the RiverMeadow invoice (“Due Date”). Any payment
                    not received on or prior to the Due Date will accrue interest at the lesser of one-and-one-half
                    percent (1.5%) per month or the highest rate permitted by law.
                </p>
                <p>
                    9.4 <span className="underline">Sales and Use Taxes</span>. End User shall be responsible for all
                    sales and use taxes (or similar taxes), if any, on the RiverMeadow Platform and shall promptly pay
                    RiverMeadow for such taxes upon RiverMeadow’s written invoice to End User for such taxes.
                </p>
                <p>
                    9.5 <span className="underline">Billing</span>. Except as otherwise set forth in the applicable
                    Order Form, (i) monthly recurring fees, if any, will be billed monthly in advance; (ii) per-server
                    fees will be billed upon completion of migration, monthly in arrears, as will other varying or
                    usage-based fees, if any; (iii) Support fees will be billed annually in advance; and (iv)
                    installation or other non-recurring fees, if any, will be billed monthly in arrears.
                </p>
                <p>
                    9.6 <span className="underline">Termination for Breach</span>. Either party shall be entitled to
                    terminate this Agreement in the event the other party commits a material breach of this Agreement
                    and fails to cure such breach within thirty (30) days of being notified in writing of such
                    breach.{' '}
                </p>
                <p>
                    9.7 <span className="underline">Discontinued Use</span>. Upon any expiration or termination of this
                    Agreement or any Order Form, End User shall immediately (i) discontinue use of the RiverMeadow
                    Platform and Documentation and (ii) remove, delete and otherwise destroy all copies (electronic or
                    otherwise) of the RiverMeadow Platform and Documentation. Notwithstanding the foregoing, End User
                    shall be permitted to use the RiverMeadow Platform for the duration of any prepaid term, unless the
                    termination is due to such End User’s uncured breach of this Agreement or the relevant Order Form.
                </p>
                <p>
                    9.8 <span className="underline">Effect of Termination</span>. Termination of this Agreement by
                    either party shall not act as a waiver of any breach of this Agreement and shall not act as a
                    release of either party from any liability for breach of such party’s obligations under this
                    Agreement. Neither party shall be liable to the other party for damages of any kind solely as a
                    result of terminating this Agreement, and termination of this Agreement by a party shall be without
                    prejudice to any other right or remedy of such party under this Agreement or applicable law.
                </p>
                <p>
                    9.9 <span className="underline">Survival</span>. Upon any expiration or termination of this
                    Agreement, the rights and obligations of the parties shall terminate, except that Sections 2.2, 2.4,
                    3.3, 5, 6, 7, 8, 9.7, 9.8 and 10 shall survive such expiration or termination. End User’s liability
                    and obligation to pay any fees or other amounts that have accrued prior to such expiration or
                    termination will also survive such expiration or termination.
                </p>

                <h3>Section 10. Miscellaneous</h3>
                <p>
                    10.1 <span className="underline">Governing Law and Jurisdiction</span>. This Agreement will be
                    governed by the laws of the Commonwealth of Massachusetts, United States without regard to any rules
                    governing conflicts of laws. Each party consents to the exclusive jurisdiction and venue of the
                    courts in the Commonwealth of Massachusetts. Notwithstanding the foregoing, either party may seek
                    injunctive or other equitable relief under this Agreement in any court of competent jurisdiction.
                </p>
                <p>
                    10.2 <span className="underline">Independent Contractors</span>. RiverMeadow and End User shall
                    perform their obligations under this Agreement as independent contractors, and nothing contained in
                    this Agreement shall be construed to create or imply a joint venture, partnership, principal-agent
                    or employment relationship between the parties.{' '}
                </p>
                <p>
                    10.3 <span className="underline">Entire Agreement</span>. This Agreement contains the entire
                    agreement between the parties with respect to the subject matter hereof and shall supersede any and
                    all prior and contemporaneous communications, representations, agreements and/or undertakings,
                    either verbal or written, between the parties in respect of the said subject matter.
                </p>
                <p>
                    10.4 <span className="underline">Amendment</span>. Any amendment or other modification of any of the
                    terms and provisions of this Agreement must be in writing and signed by a duly authorized
                    representative of each party.
                </p>
                <p>
                    10.5 <span className="underline">Severability and Limitations of Actions</span>. In the event that
                    any provision of this Agreement or the applica­tion thereof to any person or in any circumstances
                    shall be determined to be invalid, unlawful, or unenforceable to any extent, the remainder of this
                    Agreement and its application to other persons shall not be affected thereby, and the remaining
                    provi­sions of this Agreement shall continue to be valid and may be enforced to the fullest extent
                    permitted by law, and the parties agree in such event to substitute forthwith the invalid, unlawful
                    or unenforceable provision by such effective provision as will most closely correspond with the
                    legal and economic contents of the provision(s) so voided.
                </p>
                <p>
                    10.6 <span className="underline">Waiver</span>. The waiver by any party of a breach or default by
                    the other party of any provision of this Agreement shall not be construed as a waiver by such party
                    of any succeeding breach or default by the other party in the same or other provision, nor shall any
                    delay or omission on the part of either party to exercise or avail itself of any right or remedy
                    that it has or may have hereunder operate as a waiver of any such right or remedy.
                </p>
                <p>
                    10.7 <span className="underline">Assignment</span>. Neither party may assign its interest in this
                    Agreement to a third party without the advance written consent of the other party, such consent not
                    to be unreasonably withheld; provided, however, that no consent shall be required for any assignment
                    by a party to the successor of all or substantially all of the assets of such party to which this
                    Agreement relates (whether by merger, stock purchase, asset purchase or otherwise).
                </p>
                <p>
                    10.8 <span className="underline">Force Majeure</span>. Neither party shall be responsible for any
                    delay or failure in performance to the extent that such delay or failure is caused by fires,
                    earthquakes, floods, or other acts of God or severe weather conditions, by war, terrorism or other
                    violence or acts a public enemy, by strikes or other labor disputes, by laws, orders, proclamations,
                    regulations, ordinances, demands, or requirements of any governmental authority, or by any other
                    cause beyond the reasonable control of such party.
                </p>
                <p>
                    10.9 <span className="underline">Notices</span>. Any notice to be given under this Agreement shall
                    be in writing and addressed to the party at the address set forth in the applicable Order Form.
                    Notices will be deemed given and effective (i) if personally delivered, upon delivery, (ii) if sent
                    by an overnight service with tracking capabilities, upon receipt; (iii) if sent by fax or electronic
                    mail, at such time as the party which sent the notice receives confirmation of receipt by the
                    applicable method of transmittal, or (iv) if sent by certified or registered mail, within five days
                    of deposit in the mail.
                </p>
                <p>
                    10.11 <span className="underline">Advertising and Publicity</span>. RiverMeadow agrees that no
                    acknowledgement or other information concerning this Agreement and the Services provided hereunder
                    will be made public by RiverMeadow without the prior written consent of End User, such consent not
                    to be unreasonably withheld. Furthermore, RiverMeadow shall not use End User’s name, photographs,
                    logos, trademarks, copyrights, or other identifying characteristics or that of any of its
                    subsidiaries or affiliates without End User’s prior written approval, such approval not to be
                    unreasonably withheld.
                </p>
                <p>
                    10.12 <span className="underline">RiverMeadow Trademarks</span>. End User agrees to include the
                    RiverMeadow logo and other identifying information on the RiverMeadow Platform and any related
                    marketing material, and RiverMeadow grants End User a limited, non-exclusive license during the Term
                    to use RiverMeadow’s logos and trademarks solely to promote and resell the RiverMeadow Platform in
                    accordance with the rights granted to and the restrictions upon End User hereunder. End User agrees
                    to comply with RiverMeadow’s standard usage guidelines for all RiverMeadow logos and trademarks. End
                    User agrees to deliver to RiverMeadow copies of materials that include RiverMeadow logos or
                    trademarks prior to distribution or release of such materials for RiverMeadow’s approval. No
                    materials that include logos or trademarks may be distributed or released by End User without
                    RiverMeadow’s prior written approval. End User agrees that it will not at any time now or in the
                    future challenge or assist others in challenging the validity of the RiverMeadow Marks, or attempt
                    to register confusingly similar trademarks, trade names, service marks, domain names or logos.
                </p>
            </div>
        </AppModal>
    );
};
